import { render, staticRenderFns } from "./BlockReportTable.vue?vue&type=template&id=7fcfb7b8&scoped=true"
import script from "./BlockReportTable.vue?vue&type=script&lang=js"
export * from "./BlockReportTable.vue?vue&type=script&lang=js"
import style0 from "./BlockReportTable.vue?vue&type=style&index=0&id=7fcfb7b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcfb7b8",
  null
  
)

export default component.exports